import React, { ReactNode, useMemo } from 'react';
import { getMessage } from '@tcc/i18n';
import { HarvestDateLayerLegend, IntervalWithStringValue } from '../../../types';

import styles from '../../../components/cards/cardAndPreview/cardAndPreview.css';
import harvestCardStyles from './HarvestCard.css';
import { CardLabelValue } from '../CardLabelValue/CardLabelValue';

export interface HarvestDatesProps {
  harvestDatesLegend: HarvestDateLayerLegend[];
  showYieldMapLink: boolean;
  locale: string;
}

export const HARVEST_CARD_HARVEST_DATE_FORMAT = {
  month: 'short',
  year: 'numeric',
  day: 'numeric',
} as const;

const formatDate = (locale: string, date: string) => new Date(date).toLocaleDateString(locale, HARVEST_CARD_HARVEST_DATE_FORMAT);

const valueOrEmpty = (condition: boolean, value: ReactNode) => condition ? value : '--';

const hasStringValue = (entity: HarvestDateLayerLegend): entity is IntervalWithStringValue => !!entity.stringValue

export const HarvestDates: React.FC<HarvestDatesProps> = ({harvestDatesLegend, showYieldMapLink, locale }) => {
  
  const displayDates = useMemo(() => harvestDatesLegend
    .filter(date => hasStringValue(date))
    .sort((a, b) => {
      const timeA = new Date(a.stringValue as string);
      const timeB = new Date(b.stringValue as string);

      return timeB.getTime() - timeA.getTime();
    }), [harvestDatesLegend]);

  return (
    <CardLabelValue testId="harvest-harvest-dates" label={getMessage('card.harvest.dateHarvested')}>
      <div className={styles.column} data-test-id="harvest-dates-container">
        {valueOrEmpty(!!displayDates.length,
          <>
            {showYieldMapLink && <div data-test-id="harvest-dates-amount">{`${displayDates.length} ${getMessage('card.harvest.dates')}`}</div>}
            {!showYieldMapLink &&
              <div className={harvestCardStyles.harvestDates}>
                {displayDates.map(harvestDate => (
                  <div
                    data-test-id="harvest-dates-date"
                    key={harvestDate.stringValue}>
                    {formatDate(locale, harvestDate.stringValue ?? '')}
                  </div>
                ))}
              </div>
            }
          </>
        )}
      </div>
  </CardLabelValue>
)};